// Add support for "mailto" in links when rendering templates
Sys.UI.Template.allowedProtocols.push("mailto");
Sys.UI.Template.allowedProtocols.push("file");
Sys.UI.Template.allowedProtocols.push("intent");

ExoWeb.config.autoActivation = false;
ExoWeb.config.allowTypeLazyLoading = false;
ExoWeb.config.enableBatchChanges = false;
ExoWeb.config.allowObjectLazyLoading = true;
ExoWeb.config.allowListLazyLoading = true;
ExoWeb.config.calculationErrorDefault = null;

(function ($) {
	ExoWeb.setLogErrorProvider(function (message, e) {
		// This method does nothing, but it is needed in order to override the default
		// "log error provider" registered in WebService.js in ExoWeb
	});


	function updateNativeTimeField() {
		if (this.value) {
			$(this).removeClass("c-timepicker-empty");
		} else {
			$(this).addClass("c-timepicker-empty");
		}
	}

	function setupNativeTimeField() {
		var fifteenMinutesInSeconds = 900;

		$(this).attr("step", fifteenMinutesInSeconds);

		$(this).attr("novalidate", "");

		// Add a class to an ancestor hide the icon in case removal fails due to changes in DOM structure
		$(this).closest(".c-editor").addClass("c-use-native-datetime-fields");

		$(this).closest(".c-editor-time").next(".c-editor-time-icon").remove();

		updateNativeTimeField.call(this);

		// Don't allow tabbing into the text field on mobile devices
		$(this).siblings('[type="text"]').attr('tabindex', -1);

		// Don't change focus on iOS, since it causes the picker to hide and appears to transfer the
		// HH:mm time value to the focussed text field, also, iOS doesn't show focus indication anyway
		if (!Cognito.isDeviceType('iphone|ipod|ipad')) {

			if (Cognito.isDeviceType('android')) {
				// Don't allow tabbing into the time field in android
				// This emulates the native behavior of the 'time' field (as well as 'select') on android
				$(this).attr('tabindex', -1);
			}

			// Set focus to faux input when native time input is clicked (for visual focus indication)
			$(this).on('click', function () {
				$(this).siblings('[type="text"]').focus();
			});

		}
	}

	function createTimePicker() {
		// only enable timepicker for cultures that are compatible with en-US
		var longTimePattern = Sys.CultureInfo.CurrentCulture.dateTimeFormat.LongTimePattern;
		if (longTimePattern.match("^h?h[:.]mm[:.]ss tt$") ){
			$(this).timepicker({
				AMDesignator: Sys.CultureInfo.CurrentCulture.dateTimeFormat.AMDesignator,
				PMDesignator: Sys.CultureInfo.CurrentCulture.dateTimeFormat.PMDesignator,
				timeSeparator: Sys.CultureInfo.CurrentCulture.dateTimeFormat.TimeSeparator,
				twoDigitHourFormat: longTimePattern.substring(0, 2) == "hh"
			})
			.on("changeTime.timepicker", function (e) {
				$simulateMutationEvent(this, "change", false, true);
			});
		}
		// 24 hour time
		else if (longTimePattern.match("^H?H[:.]mm[:.]ss$")) {
			$(this).timepicker({
				showMeridian: false,
				timeSeparator: Sys.CultureInfo.CurrentCulture.dateTimeFormat.TimeSeparator,
				twoDigitHourFormat: longTimePattern.substring(0, 2) == "HH"
			})
			.on("changeTime.timepicker", function (e) {
				$simulateMutationEvent(this, "change", false, true);
			});
		}
	}

	function createSignature() {

		var sig = $(this).parent();

		window.setTimeout(function () {
			var jsignature = sig.children().first();
			var img = sig.find("img");

			// If no controls found, abort
			if (!jsignature.length || !img.length) return;

			// Initialize the signature control
			jsignature.jSignature({ "background-color": "transparent", color: img.css("color"), "decor-color": "#eee", height: 150, width: "100%" });

			// Hide the signature control if a signature is already present
			// The .not is to exlcude the c-readonly added to container c-field and c-section for read-only support
			if (img.attr("src").length || sig.closest(".c-readonly").not(".c-field, .c-section").length) {
				jsignature.hide();

				if (img.attr("src").length) {
					sig.addClass("c-signature-present");

					// To have symmetry with other signature html
					sig.closest('.c-editor').find('> div').addClass("c-signature-present");
					jsignature.jSignature("importData", img.attr("src"));
				}
			}

			// Otherwise, hide the image placeholder
			else
				img.hide();

			if ($(jsignature).parents(".c-signature").hasClass("c-readonly")) {
				$(jsignature).jSignature("disable")
			}

			// Subscribe to change event
			jsignature.bind('change', function (e) {

				// Get the signature
				var signature = $parentContextData(this);

				// No signature present
				if (jsignature.jSignature("getData", "native").length !== 0 && jsignature.is(":visible")) {
					// Set the signature SVG and PNG properties
					signature.set_Svg("data:" + jsignature.jSignature("getData", "svgbase64").join(","));
					signature.set_Png("data:" + jsignature.jSignature("getData", "image").join(","));

					// Add a class to indicate that a signature is present
					jsignature.parent().addClass("c-signature-present");
				}
			});
		}, 0);
	}

	function createAutoComplete() {
		$(this).typeahead({
		    minLength: 0,
            source: null
		});
	}

	// The toggle has been re-implemented to no longer depend on cognito-toggle.js
	//function createToggle() {
	//	var that = $(this);
	//	$(this)['bootstrapSwitch']();
	//	$(this).bootstrapSwitch('setAnimated', true);
	//	$(this).parents(".has-switch").on("switch-change", function () {
	//		$simulateMutationEvent(that[0], "change", false, true);
	//	});
	//}

	function createPlaceholder() {
		if (!$.fn.placeholder) return;

		$(this).placeholder();
	}

	$(document.documentElement).ever({
		selector: "div.c-signature img",
		bound: createSignature
	});

	$(document.documentElement).ever({
		selector: "input[type=text].c-timepicker",
		bound: createTimePicker
	});

	$(document.documentElement).ever({
		selector: "input[type=time].c-timepicker",
		bound: setupNativeTimeField
	});

	$(document.documentElement).on("input change focus", "input[type=time].c-timepicker", updateNativeTimeField);

	$(document.documentElement).ever({
		selector: "input.c-autocomplete",
		bound: createAutoComplete
	});

	// The toggle has been re-implemented to no longer depend on cognito-toggle.js
	//$(document.documentElement).ever({
	//	selector: "input.c-toggle",
	//	bound: createToggle
	//});

	$(document.documentElement).ever({
		selector: "input,textarea",
		bound: createPlaceholder
	});

	$(document.documentElement).ever({
		selector: "input.c-mask",
		bound: function () {
			var mask = $(this).attr("data-mask");
			$(this).mask(mask, { autoclear: false, autoinit: false });
		},
		unbound: function () {
			$(this).unmask();
		}
	});

	// Clear signatures when delete button is clicked
	$(document.documentElement).on("click", ".c-signature-present .c-signature-glyph", function () {
		// Get the signature
		var signature = $parentContextData(this);

		// Clear the signature SVG and PNG properties
		signature.set_Svg(null);
		signature.set_Png(null);

		// Remove signature indicator
		$(this).parent().removeClass("c-signature-present");

		// Reset and show the signature control
		$(this).parent().children().first().jSignature("reset").show();
		$(this).parent().children("img").hide();
		window.setTimeout(Cognito.resize);
	});

	// Toggle
	// Trigger toggle with JS instead of <label> per AXE report
	$(document.documentElement).on('click', '.c-toggle--container', function () {
		$(this).siblings('[type="checkbox"]').trigger('click').trigger('focus');
	});

})(ExoJQuery || jQuery);
